<template>
  <div>

    <Head title="Servers" />
    <h1 class="mb-8 text-3xl font-bold">Server</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <Link class="btn-primary-100" href="/servers/create">
      <span>Server</span>
      <span class="hidden md:inline">&nbsp;Erstellen</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Name</th>
            <th class="pb-4 pt-6 px-6">IP</th>
            <th class="pb-4 pt-6 px-6">Kunden</th>
            <th class="pb-4 pt-6 px-6">Domains</th>
            <th class="pb-4 pt-6 px-6">Link</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="server in servers.data" :key="server.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-primary-200" :href="`/servers/${server.id}/edit`">
              {{ server.name }}
              <icon v-if="server.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 ml-2 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/servers/${server.id}/edit`" tabindex="-1">
              {{ server.ip }}
              <icon @click="copyToClipboard(server.ip)" name="clipboard"
                class="block w-4 h-4 ml-2 fill-white hover:fill-primary-100" />
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/servers/${server.id}/edit`" tabindex="-1">
              {{ server.customers.length }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/servers/${server.id}/edit`" tabindex="-1">
              {{ server.domains }}
              </Link>
            </td>
            <td class="border-t">
              <div class="px-4 flex items-center">
                <a class="btn-primary-100" target="_blank" :href="server.url"> <span>Zu Plesk</span></a>
              </div>
            </td>

            <td class="w-px border-t">
              <Link class="flex items-center px-4" :href="`/servers/${server.id}/edit`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="servers.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">No servers found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="servers.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    servers: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/servers', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    async copyToClipboard(mytext, event) {
      try {
        await navigator.clipboard.writeText(mytext);
        if (event) {
          event.preventDefault()
        }
        alert('Copied');
      } catch ($e) {
        alert('Cannot copy');
      }
    }
  },
}
</script>
